module.exports = __webpack_public_path__ + "static/media/rating_mature.00c5028b.svg";